import analytics from "../analytics/analytics.js";
async function validateHotelDetailsURL(url) {
    try {
        const response = await fetch(url, {
            method: 'HEAD'
        });
        if (200 === response.status) return url;
        throw Error(`status code: ${response.status}`);
    } catch (e) {
        analytics.logError({
            loggedFrom: 'locationMetadataLinkClickHandler:validateHotelDetailsURL',
            message: 'invalid hotel details URL',
            url,
            error: e.message
        });
    }
    return '';
}
export { validateHotelDetailsURL };
